<template>
  <div class="pagination-container align-items-center d-flex justify-content-between flex-wrap">


    <div class="fw-bolder fs-5">
      <template v-if="total > 0">
        Page {{ currentPage }} ▪️ De {{ firstItem }}
        à {{ firstItem + itemCount - 1 }}
        <template v-if="matchCount">
          sur {{ matchCount }}
        </template>
        <template v-if="total">
          [{{ total }}]
        </template>
      </template>
    </div>

    <div class="d-flex justify-content-end align-items-center">
      <button
          v-if="!visiblePages.includes(1)"
          @click.stop="changePage(currentPage - 1)"
          :disabled="currentPage === 1"
          class="pagination-button bg-hover-light-primary">
        <i class="fad fa-angle-left"></i>
      </button>
      <button
          v-for="page in visiblePages"
          :key="page"
          @click.stop="changePage(page)"
          :class="{ 'active': page === currentPage }"
          class="pagination-button bg-hover-light-primary">
        {{ page }}
      </button>

      <button v-if="!visiblePages.includes(totalPages)"
              @click.stop="changePage(currentPage + 1)"
              :disabled="currentPage === totalPages"
              class="pagination-button  bg-hover-light-primary">
        <i class="fad fa-angle-right"></i>
      </button>
    </div>
  </div>
</template>


<script lang="ts">
import {Vue, Component, Prop} from 'vue-property-decorator';

@Component({})
export default class CustomPagination extends Vue {


  @Prop({default: 0}) total !: number;
  @Prop({default: 10}) itemsPerPage !: number;
  @Prop({default: 0}) currentPage !: number;
  @Prop({default: 0}) matchCount ?: number
  @Prop({default: 0}) itemCount !: number

  get totalPages(): number {
    return Math.ceil(this.total / this.itemsPerPage);
  }

  get firstItem() {
    return (((this.currentPage - 1) * this.itemsPerPage) + 1)
  }

  get itemLength() {
    return (((this.currentPage - 1) * this.itemsPerPage) + 1)
  }

  get visiblePages(): (string | number)[] {
    const delta = 4;
    let startPage = Math.max(1, this.currentPage - delta);
    let endPage = Math.min(this.totalPages, this.currentPage + delta);

    if (startPage > 2) {
      return [1, '...', ...Array.from({length: endPage - startPage + 1}, (_, i) => startPage + i)];
    }
    if (endPage < this.totalPages - 1) {
      return [...Array.from({length: endPage - startPage + 1}, (_, i) => startPage + i), '...', this.totalPages];
    }
    return Array.from({length: endPage - startPage + 1}, (_, i) => startPage + i);
  }


  changePage(page: number | string): void {
    page = parseInt(page + '')
    if (!isNaN(page) && page >= 1 && page <= this.totalPages) {
      this.$emit('update:currentPage', page);
    }
  }

}
</script>


<style scoped>

.pagination-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  border-radius: 4px;
  //gap: 8px;
}

.pagination-button {
  padding: 8px 16px;
  cursor: pointer;
  background-color: #f0f0f0;
  color: gray;
  border: none;
}

.pagination-container .pagination-button:first-child {
  border-radius: 5px 0 0 5px;
}

.pagination-container .pagination-button:last-child {
  border-radius: 0 5px 5px 0;

}

.pagination-button.active {
  background-color: var(--bs-primary);
  font-weight: bolder;
  color: white;
}

.pagination-button:disabled {
  background-color: #dcdcdc;
  cursor: not-allowed;
}

.ellipsis {
  margin: 0 8px;
  font-size: 18px;
}
</style>
